
  if (!customElements.get('kellermont-accordion')) {
    customElements.define('kellermont-accordion', class extends HTMLElement {
      connectedCallback() {
        if(this.initialized)return;this.initialized=true;this.items = this.querySelectorAll('.accordion-item');
        
        this.items.forEach(item => {
          const btn = item.querySelector('.accordion-toggle');
          
          btn.addEventListener('click', () => {
            const isOpen = item.classList.contains('is-open');
            
            this.items.forEach(sibling => {
              sibling.classList.remove('is-open');
              sibling.querySelector('.accordion-toggle').setAttribute('aria-expanded', 'false');
            });

            if (!isOpen) {
              item.classList.add('is-open');
              btn.setAttribute('aria-expanded', 'true');
            }
          });
        });
      }
    });
  }
